const sizesSettings = {
  //breakpoints: [`600px`, `900px`, `1100px`],,
  sizes: {
    // container: 1200,
    // s: 300,
    // m: 600,
    // l: 900,
  },
}

export default sizesSettings
